import React, { useState, useEffect } from "react";
import {
    Link
} from "react-router-dom";

import useLocalStorage from 'use-local-storage'
import moment from 'moment';

import { 
    Layout,
    Menu,
    Row, 
    Col,
    Button
} from 'antd';

import { 
    FiAlignRight, 
    FiX,
    FiSun,
    FiMoon 
} from "react-icons/fi";

import { 
    FaGem,
    FaRocket,
    FaEye
} from "react-icons/fa";

// import stylecss
import '../assets/css/style.css';

import Logo from '../assets/images/logo.png';
import Banner from '../assets/images/banner.jpeg';
import Banner_car from '../assets/images/intro/banner_car.png';
import Team from '../assets/images/team/team.png';
import Partner_1 from '../assets/images/tech_partners/bsc.svg';
import Partner_2 from '../assets/images/tech_partners/partner-image.png';
import Partner_3 from '../assets/images/tech_partners/partner-image2.png';
import Partner_4 from '../assets/images/tech_partners/partner-image4.png';
import Partner_5 from '../assets/images/tech_partners/partner-image5.png';
import Partner_6 from '../assets/images/tech_partners/partner-image6.png';
import Partner_7 from '../assets/images/tech_partners/partner-image3.png';
import Icon_mail from '../assets/images/icons/mail.svg';
import Icon_location from '../assets/images/icons/location.svg';

// light img
import Banner_Light from '../assets/images/intro/landing-banner-light.png';
import Banner_Car_Light from '../assets/images/intro/banner_car_light.png';

// import component
import Socials from "../components/Socials/social";

const { Header, Footer, Content } = Layout;

const tech_partners = [Partner_1, Partner_2, Partner_3, Partner_4, Partner_5, Partner_6, Partner_7];

function Landing() {

    let current_time = moment().format("HH");

    const [showMenu, setShowMenu ] = useState(false);
    const [size, setSize] = useState('large');

    const defaultDarkLanding = window.matchMedia('(prefers-color-scheme: light)').matches;
    const [themeLanding, setThemeLanding] = useLocalStorage('theme', defaultDarkLanding ? 'light' : 'dark');

    const checkModeThemeLanding = () => {
        if( current_time > 6  && current_time < 18 ){
            setThemeLanding('light');
        } else{
            setThemeLanding('dark');
        }
    }

    const switchTheme = () => {
        const newTheme = themeLanding === 'light' ? 'dark' : 'light';
        setThemeLanding(newTheme);
    }

    useEffect(() => {
        checkModeThemeLanding();
    }, [current_time]);


    useEffect(() => {
        window.addEventListener('scroll', isSticky);
        return () => {
            window.removeEventListener('scroll', isSticky);
        };
    });

           
    /* Method that will fix header after a specific scrollable */
    const isSticky = (e) => {
        const header = document.querySelector('.header-landing');
        const scrollTop = window.scrollY;
        scrollTop >= 250 ? header.classList.add('is-sticky') : header.classList.remove('is-sticky');
    };


    return (
        <>
            <Layout className="layout-landing" data-theme={themeLanding}>
                <Header className="header-landing">
                    <Row justify="space-around" align="middle">
                        <Col xs={12} sm={4} md={6} lg={8} xl={4}>
                            <div className="logo">
                                <img className="logo-landing" src={Logo} alt="" />
                            </div>
                        </Col>
                        <Col xs={0} sm={4} md={4} lg={4} xl={12}>
                            <Menu className="nav-wrap">
                                <Menu.Item className="nav-item" key="about-us">About Us</Menu.Item>
                                <Menu.Item className="nav-item" key="2">Product</Menu.Item>
                                <Menu.Item className="nav-item" key="3">Developers</Menu.Item>
                                <Menu.Item className="nav-item" key="4">Blogs</Menu.Item>
                                <Menu.Item className="nav-item" key="5">Trading</Menu.Item>
                            </Menu>
                        </Col>
                        <Col xs={12} sm={4} md={4} lg={4} xl={4}>
                            <div className="d-flex align-items-center btn-landing-wrap">
                                <Button className="btn-launchpad btn-launchpad-top hide-mobile" type="primary" shape="round" size={size}>
                                    <Link to="/">
                                        <FaRocket /> Launch App
                                    </Link>
                                </Button>
                                <div className="menu-mobile-icon">
                                    <FiAlignRight onClick={() => setShowMenu(true)} />
                                </div>
                            </div>
                        </Col>
                    </Row>
                    <div className={showMenu ? "menu-mobile-wrap show-menu" :"menu-mobile-wrap"}>
                        <div className="menu-mobile-container">
                            <div className="close-menu-mobile">
                                <FiX onClick={() => setShowMenu(false)} />
                            </div>
                            <Menu className="nav-wrap">
                                <Menu.Item className="nav-item" key="1">About Us</Menu.Item>
                                <Menu.Item className="nav-item" key="2">Product</Menu.Item>
                                <Menu.Item className="nav-item" key="3">Developers</Menu.Item>
                                <Menu.Item className="nav-item" key="4">Blogs</Menu.Item>
                            </Menu>
                            <Button className="btn-launchpad btn-launchpad-top" type="primary" shape="round" size={size}>
                                <Link to="/dashboard">
                                    <FaRocket /> Launch App
                                </Link>
                            </Button>
                        </div>
                    </div>
                </Header>

                <Content className="main-landing">
                    <div className="landing-intro" style={{backgroundImage: `url(${Banner})`}}>
                        <div className="racer-text-intro">
                            <span className="txt">Oculus</span>
                        </div>
                    </div>
                    <div className="landing-about">
                        <Row align="middle" className="container">
                            <Col xs={24} xl={12}>
                                <div className="landing-about-content">
                                    <h1 className="landing-heading-text">
                                        Launchpad Brings Projects To Success
                                    </h1>
                                    <p className="text-white">The long-term vision is to become a multi-functional and universal platform that meets all customers' needs.</p>
                                    <Button className="btn-launchpad btn-left" type="primary" shape="round" size={size}>
                                        <FaRocket /> Launch App
                                    </Button>
                                </div>  
                            </Col>
                            <Col xs={24} xl={12}>
                                <div className="car-wrap">
                                    <img src={Logo}  alt="" className="car-container shape-animation" />
                                </div>
                            </Col>
                        </Row>
                    </div>
                    <div className="landing-overview">
                        <div className="landing-overview-shape">
                            <img src={themeLanding === 'light' ? Banner_Car_Light: Banner_car} alt="" />
                        </div>
                        <Row align="middle" justify="center" gutter={30} className="container">
                            <Col xs={24} xl={12}>
                                <div className="landing-overview-content">
                                    <span className="landing-overview-tag text-primary">Overview</span>
                                    <h1 className="landing-overview-heading">
                                        Ecosystem
                                    </h1>
                                    <p className="text-white">RaceStarter is a MultiChain Decentralized Finance platform with a Web3 ecosystem. At RaceStarter, we support create and exchange value.</p>
                                    <Button className="btn-launchpad" type="primary" shape="round" size={size}>
                                        Read more
                                    </Button>
                                </div>  
                            </Col>
                            <Col xs={24} xl={12}>
                                <div className="landing-overview-content">
                                    <span className="landing-overview-tag text-primary">Upcoming 2022</span>
                                    <h1 className="landing-overview-heading">
                                        Launchpad
                                    </h1>
                                    <p className="text-white">Launchpad fundraising platform is researched and developed by RaceStarter to apply Multichain technology to increase accessibility to users.</p>
                                    <Button className="btn-launchpad" type="primary" shape="round" size={size}>
                                        Read more
                                    </Button>
                                </div>    
                            </Col>
                        </Row>
                        <div className="landing-overview-container">
                            <Row align="start" justify="center" gutter={32} className="container">
                                <Col xs={24} xl={24}>
                                    <h1 className="landing-heading-text text-center">
                                        Launchpad Brings Projects To Success
                                    </h1>
                                    <h4 className="text-center">Launchpad Overview</h4>
                                    <p className="text-white text-center">Launchpad is a decentralized finance using Web3.0 ecosystem. Its mission is to assist enterprises all over the world (especially startups and SMEs), to successfully mobilise capital from a potential community of investors, thus enhancing creativity and altering enterprise’s values.</p>
                                    <p className="text-white text-center">Its mission is to assist enterprises all over the world (especially startups and SMEs), to successfully mobilise capital from a potential community of investors, thus enhancing creativity and altering enterprise’s values.</p>
                                </Col>
                                <Col xs={24} xl={12}>
                                    <div className="landing-overview-boxicon">
                                        <div className="landing-overview-icon">
                                            <FaEye />
                                        </div>
                                        
                                        <h1 className="landing-boxicon-heading">
                                            Vision
                                        </h1>
                                        <p className="text-white">Launchpad  aims to build a decentralized finance ecosystem, with procedural products, to stimulate traditional enterprises
to solve their resources problems, especially finance resource.</p>
                                    </div>  
                                </Col>
                                <Col xs={24} xl={12}>
                                    <div className="landing-overview-boxicon">
                                        <div className="landing-overview-icon">
                                            <FaGem />
                                        </div>
                                        <h1 className="landing-boxicon-heading">
                                            Mission
                                        </h1>
                                        <p className="text-white">Launchpad mission is to make Blockchain more extensively and effortlessly applied in all fields of our life.</p>
                                    </div>  
                                </Col>
                            </Row>
                        </div>
                    </div>
                    <div className="landing-teams">
                        <Row className="container" align="middle" justify="center">
                            <Col xs={24} xl={16}>
                                <div className="text-center">
                                    <h1 className="landing-heading-text">
                                        Human Of Launchpad
                                    </h1>
                                    <p className="text-white">The development team fully converges all elements, talent, creativity, dynamism, and broad activity in the Crypto market, contributing to the unlimited vision of RaceStarter.</p>
                                </div>
                            </Col>
                            <Col span={24}>
                                <div className="team-wrap">
                                    <div className="box-team">
                                        <img src={Team} alt="" />
                                        <span className="box-team-title">N.V NHAT HOANG</span>
                                        <span className="box-team-office">CTO</span>
                                        <Socials tw="#" linkedin="#" className="team-social" />
                                    </div>
                                    <div className="box-team">
                                        <img src={Team} alt="" />
                                        <span className="box-team-title">N.V NHAT HOANG</span>
                                        <span className="box-team-office">Chief Strategy</span>
                                        <Socials tw="#" linkedin="#" className="team-social" />
                                    </div>
                                    <div className="box-team">
                                        <img src={Team} alt="" />
                                        <span className="box-team-title">N.V NHAT HOANG</span>
                                        <span className="box-team-office">CEO</span>
                                        <Socials tw="#" linkedin="#" className="team-social" />
                                    </div>
                                    <div className="box-team">
                                        <img src={Team} alt="" />
                                        <span className="box-team-title">N.V NHAT HOANG</span>
                                        <span className="box-team-office">CTO</span>
                                        <Socials tw="#" linkedin="#" className="team-social" />
                                    </div>
                                </div>
                            </Col>
                        </Row>
                    </div>
                    <div className="landing-advisor">
                        <Row className="container" align="middle" justify="center">
                            <Col xs={24} xl={16}>
                                <div className="text-center">
                                    <h1 className="landing-heading-text">
                                        Our Partners
                                    </h1>
                                </div>
                            </Col>
                            <Col span={24}>
                                <div className="advisor-wrap">
                                    <div className="advisor-card">
                                        <div className="advisor-card-img">
                                            <img src={Team} alt="" />
                                        </div>
                                        <div className="advisor-card-content">
                                            <span className="title text-white">N.V NHAT HOANG</span>
                                            <span className="office text-primary">Product Advisor</span>
                                            <Socials tw="#" linkedin="#" className="team-social" />
                                        </div>
                                    </div>
                                    <div className="advisor-card">
                                        <div className="advisor-card-img">
                                            <img src={Team} alt="" />
                                        </div>
                                        <div className="advisor-card-content">
                                            <span className="title text-white">N.V NHAT HOANG</span>
                                            <span className="office text-primary">R&D Strategic Advisor</span>
                                            <Socials tw="#" linkedin="#" className="team-social" />
                                        </div>
                                    </div>
                                    <div className="advisor-card">
                                        <div className="advisor-card-img">
                                            <img src={Team} alt="" />
                                        </div>
                                        <div className="advisor-card-content">
                                            <span className="title text-white">N.V NHAT HOANG</span>
                                            <span className="office text-primary">Product Advisor</span>
                                            <Socials tw="#" linkedin="#" className="team-social" />
                                        </div>
                                    </div>
                                </div>
                            </Col>
                        </Row>
                    </div>
                    <div className="landing-partners">
                        <Row className="container" align="middle" justify="center">
                            <Col xs={24} xl={16}>
                                <div className="text-center">
                                    <h1 className="landing-heading-text">
                                        Our Partners
                                    </h1>
                                </div>
                            </Col>
                            <Col span={24}>
                                <div className="partners-wrap">
                                    {
                                        tech_partners.map((item,index) => {
                                            return(
                                            <div className="partner-item" key={index}>
                                                <img src={item} alt="" />
                                            </div>
                                            )
                                        })
                                    }
                                    
                                </div>
                            </Col>
                        </Row>
                    </div>
                    <div className="landing-footer">
                        {/* <div className="landing-footer-shape">
                            <img src={ themeLanding === 'light' ? Banner_Footer_Light :  Banner_Footer} alt="" />
                        </div> */}
                        <Row className="container" align="middle" justify="center">
                            <Col xs={24} xl={16}>
                                <div className="text-center">
                                    <h1 className="landing-heading-text">
                                        Become Our Partners
                                    </h1>
                                    <p className="text-white">RaceStarter aims to build a decentralized finance ecosystem, with procedural products, to stimulate traditional enterprises to approach and apply Blockchain</p>
                                    <Button className="btn-launchpad" type="primary" shape="round" size={size}>
                                        Connect with Launchpad
                                    </Button>
                                </div>
                            </Col>
                        </Row>
                    </div>
                </Content>
                <Footer className="footers-landing">
                    <Row className="container" align="middle" justify="center">
                        <Col xs={24} xl={8} className="footer-box-logo">
                            <img src={Logo} alt="" />
                            <p className="text-white">RaceStarter is a MultiChain Decentralized Finance platform with a Web3 ecosystem. At RaceStarter, we support create and exchange value.</p>
                            <Socials tw="#" discord="#" telegram="#" linkedin="#"></Socials>
                        </Col>
                        <Col span={16} xs={24} xl={16}>
                            <div className="footers-menu-wrap">
                                <div className="footers-menu-item">
                                    <span className="footers-menu-item-title">
                                        Developers
                                    </span>
                                    <ul>
                                        <li>
                                            <a href="#">Roadmap</a>
                                        </li>
                                        <li>
                                            <a href="#">Litepaper</a>
                                        </li>
                                        <li>
                                            <a href="#">Pitch Deck</a>
                                        </li>
                                        <li>
                                            <a href="#">Whitepaper</a>
                                        </li>
                                    </ul>
                                </div>
                                <div className="footers-menu-item">
                                    <span className="footers-menu-item-title">
                                        RaceStarter Token
                                    </span>
                                    <ul>
                                        <li>
                                            <a href="#">What is RaceStarter?</a>
                                        </li>
                                        <li>
                                            <a href="#">How to buy $RS</a>
                                        </li>
                                        <li>
                                            <a href="#">Token Metrics</a>
                                        </li>
                                        <li>
                                            <a href="#">Vesting Schedule</a>
                                        </li>
                                    </ul>
                                </div>
                                <div className="footers-menu-item">
                                    <span className="footers-menu-item-title">
                                        About Us
                                    </span>
                                    <ul>
                                        <li>
                                            <a href="#">Overview</a>
                                        </li>
                                        <li>
                                            <a href="#">Team</a>
                                        </li>
                                        <li>
                                            <a href="#">Partners</a>
                                        </li>
                                        <li>
                                            <a href="#">Blogs</a>
                                        </li>
                                    </ul>
                                </div>
                                <div className="footers-menu-item">
                                    <span className="footers-menu-item-title">
                                        Contact Us
                                    </span>
                                    <ul>
                                        <li>
                                            <a href="#"><img src={Icon_mail} alt="" /> hi@racestarter.finance</a>
                                        </li>
                                        <li>
                                            <a href="#"><img src={Icon_location} alt="" /> 121 Hoang Hoa Tham, Ward 26, Binh Thanh District, HCMC</a>
                                        </li>
                                    </ul>
                                </div>
                            </div>
                        </Col>
                    </Row>
                </Footer>
            </Layout>
        </>
    );
}

export default Landing;
